import "./styled.css";
import { getDic } from "../../assets/i18n/dictionary";

export default function AlreadyRegistered({
  configOptions,
  lightenHex,
  setStep
}) {
  return (
    <div className="div-card" style={{
      background: lightenHex(configOptions.backgroundColor, 20),
      color: configOptions.textColor
    }}>
      <div className="div-iconCam" style={{ backgroundColor: "#00BD00" }}>✅</div>

      <h1 style={{ color: lightenHex(configOptions.textColor, 40), marginTop: 16 }}>{getDic("foto-ja-cadastrada")}</h1>

      <span style={{ color: lightenHex(configOptions.textColor) }}>{getDic("ja-realizou-cadastro-facial")}</span>

      <button
        className="button-takePhoto"
        onClick={() => setStep(1)}
        style={{
          background: configOptions.buttonBackgroundColor,
          color: configOptions.buttonTextColor,
          marginTop: 24
        }}
      >
        <i style={{ marginRight: 10 }}>🔄</i>
        <span>{getDic("refazer-cadastro").toUpperCase()}</span>
      </button>
    </div>
  );
}
